import { engineComponent } from "neo-common";
import { BaseModel } from "./BaseModel";
import { BaseView } from "./BaseView";
import { Controller } from "../Controller";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { Machine } from "../Machine";

@engineComponent(ComponentTypes.Controller)
export class BaseController extends Controller {
    public static readonly SpinReceived: string = "eventSpinReceived";
    public static readonly RespinReceived: string = "eventRespinReceived";
    public static readonly MachineStopped: string = "eventMachineStopped";
    public static readonly WinCalculationFinished: string = "eventWinCalculationFinished";
    public static readonly AllWinsFinished: string = "eventAllWinsFinished";
    public static readonly OutroFinished: string = "eventOutroFinished";
    public static readonly IntroFinished: string = "eventIntroFinished";

    public static readonly MachineStoppedWithAnimation: string = "eventMachineStoppedWithAnimation";
    public static readonly QuickWinCalculationFinished: string = "eventQuickWinCalculationFinished";
    public static readonly StickyAnimationFinished: string = "eventStickyAnimationFinished";

    protected _view: BaseView;
    protected _model: BaseModel;

    startInitialization(view: any): void {
        if (DEBUG) {
            this.log("startInitialization");
        }

        if (view instanceof BaseView) {
            this._view = view;
        } else {
            if (DEBUG) {
                this.log("ERROR view is not instance of BaseView");
            }
        }

        this._model = new BaseModel(this);
    }

    disableLogo(): void {
        this._view.disableLogo();
    }

    initReceived(): void {
        this._view.initReceived(this);
    }

    initIntro(): void {
        this._view.initIntro();
    }

    collect(): void {
        this._view.collect();
    }

    /**
     * @param reels Bit map representation of spinned reels.
     */
    spin(reels: number): void {
        this._model.spin();
        this._view.spin(reels);
    }

    buyFeature(reels: number): void {
        this._model.buyFeature();
        this._view.changeBet();
        this._view.spin(reels);
    }

    respin(reels: number): void {
        this._model.respin();
        this._view.respin(reels);
    }

    stop(): void {
        this._view.stop();
    }

    spinReceived(): void {
        this._view.spinReceived();
        this.emit(BaseController.SpinReceived);
    }

    respinReceived(): void {
        Machine.Respin = true;
        this._view.spinReceived();
        this.emit(BaseController.RespinReceived);
    }

    machineStoppedWithAnimation(): void {
        this.emit(BaseController.MachineStoppedWithAnimation);
    }

    quickWinCalculationFinished(): void {
        this.emit(BaseController.QuickWinCalculationFinished);
    }

    machineStopped(isHighWins: boolean = false): void {
        this.emit(BaseController.MachineStopped, isHighWins);
    }

    winCalculationFinished(): void {
        this.emit(BaseController.WinCalculationFinished);
    }

    allWinsFinished(): void {
        this.emit(BaseController.AllWinsFinished);
    }

    resetWinAnimator(): void {
        this._view.resetWinAnimator();
    }

    intro(long: boolean = false, previousModule: string): void {
        this._view.intro(long, previousModule);
    }

    introFinished(): void {
        this.emit(BaseController.IntroFinished);
    }

    outro(): void {
        this._view.outro();
    }

    outroFinished(): void {
        this.emit(BaseController.OutroFinished);
    }

    stickyAnimationFinished(): void {
        this.emit(BaseController.StickyAnimationFinished);
    }

    disableBase(): void {
        this._view.disableBase();
    }

    resetScreen(): void {
        this._view.resetScreen();
    }

    toggleSounds(enable: boolean): void {
        this._view.toggleSounds(enable);
    }

    changeBet(): void {
        this._view.changeBet();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Base/BaseController.ts
 **/